import Store from '@phoenix/components/Store';

Object.assign(window, {
  Store,
});
